module.exports = __webpack_public_path__ + "static/client-a8b6de7bcabba7f73427f7f9286e44af.png";